import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominasNominaConfiguracionPagosColaboradorObservacionesComponent {
  data
  requerido
  onChange

  $onChanges (changes) {
    if (changes.requerido && !changes.requerido.isFirstChange()) {
      this.editando = this.requerido
    }
  }

  actualizar () {
    this.onChange({$event: {data: this.data || ''}})
  }
}

module.component('nominasNominaConfiguracionPagosColaboradorObservaciones', {
  controller: NominasNominaConfiguracionPagosColaboradorObservacionesComponent,
  template,
  bindings: {
    data: '<',
    requerido: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/configuracion/pagos/colaborador/observaciones/component.js